import OpentokService from './OpentokService';
import Recorder from './Recorder';
import DeviceManager from './DeviceManager';


export default class OpentokRecording {
    /**
     * Creates plugin with config
     * @param {Object.<{
     *  opentokSdkUrl: string,
     *  injectedApiUrl: string,
     *  recordingPath: string,
     *  spitRecordingOnResolutionChange: boolean,
     *  recordAudio: boolean
     *  }>} config parameters sent to the plugin
     */
    constructor(config) {
        this.config = Object.assign({}, OpentokRecording.defaults, config);

        if (this.config.recordAudio !== undefined) {
            this.config.streamConstraints.audio = this.config.recordAudio;
        }

        if (this.config.videoResolution !== undefined) {
            this.config.streamConstraints.video = JSON.parse(this.config.videoResolution);
        }

        this.requirements = ['navigator.getUserMedia'];
        this.opentokService = new OpentokService(this.config);
    }

    /**
     * @param {EnvironmentDetectionResult} info contains information about environment
     * @return {boolean}
     */
    check(info) {
        for (const requirement of this.requirements) {
            if (info.capabilities.indexOf(requirement) === -1) {
                return false;
            }
        }

        if (info.webcams.length < 1) {
            return false;
        }

        if (info.capabilities.indexOf('https') === -1 && info.capabilities.indexOf('localhost') === -1) {
            return false;
        }

        this.config.isSafari = (info.browser.name && info.browser.name.toLowerCase() === 'safari');
        this.config.isChrome = (info.browser.name && info.browser.name.toLowerCase() === 'chrome');
        this.config.isMobile = info.platform && (info.platform.type === 'mobile' || info.platform.type === 'tablet');
        return true;
    }


    /**
     * Initializes plugin by
     * - loading dependencies
     * - getting Opentok token
     * - initializing Opentok Session
     * @return {Promise}
     */
    init() {
        return this.opentokService.init()
            .then(() => {
                this.recordingApi = {
                    Recorder: Recorder.bind(
                        null,
                        {
                            isSafari: this.config.isSafari,
                            recordingPath: this.config.storage.path,
                            spitRecordingOnResolutionChange: this.config.spitRecordingOnResolutionChange === true,
                        },
                        this.opentokService,
                    ),
                    mediaDevices: new DeviceManager(this.config.streamConstraints),
                    getTechnology() {
                        return 'webrtc';
                    },
                };
                return this.recordingApi;
            });
    }
}

OpentokRecording.defaults = {
    startRecordingEndpoint: '/api/v1/unifiedrecorder/startRecording',
    stopRecordingEndpoint: '/api/v1/unifiedrecorder/stopRecording',
    getOpentokTokenEndpoint: '/api/v1/unifiedrecorder/getToken',
    opentokSdkLoadingTimeout: 30000,
    streamConstraints: {
        video: {
            width: {
                max: 640,
            },
            height: {
                max: 480,
            },
        },
        audio: true,
    },
};
